export const manifest = {
  screens: {
    scr_o45ezy: { name: "The Campaign Cost Disruptor", route: "/", state: {"slide":0}, position: {"x":42160,"y":220} },
    scr_kp0esk: { name: "Lundbeck Snakker Campaign Suggestion", route: "/", state: {"slide":1}, position: {"x":160,"y":220} },
    scr_jjl7zs: { name: "Meet Snakker", route: "/", state: {"slide":2}, position: {"x":32360,"y":220} },
    scr_ie2avj: { name: "Each Campaign Becomes an Interactive Journey", route: "/", state: {"slide":3}, position: {"x":33760,"y":220} },
    scr_ndc1ch: { name: "One Campaign, Every Relevant Channel", route: "/", state: {"slide":4}, position: {"x":35160,"y":220} },
    scr_0jxrdn: { name: "A Calendar, Not a Campaign-by-Campaign Ask", route: "/", state: {"slide":5}, position: {"x":37960,"y":220} },
    scr_a7vxvx: { name: "What Is a Snak?", route: "/", state: {"slide":6}, position: {"x":39360,"y":220} },
    scr_5vmyfr: { name: "Closing Recommendation", route: "/", state: {"slide":7}, position: {"x":22560,"y":220} },
  },
  sections: {
    sec_cmsdzd: { name: "Business Proposal Flow", x: 0, y: 0, width: 43520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_cmsdzd", children: [
      { kind: "screen", id: "scr_kp0esk" },
      { kind: "screen", id: "scr_skshpg" },
      { kind: "screen", id: "scr_wyirxp" },
      { kind: "screen", id: "scr_5vmyfr" },
      { kind: "screen", id: "scr_qpa782" },
      { kind: "screen", id: "scr_mabatu" },
      { kind: "screen", id: "scr_xx25ix" },
      { kind: "screen", id: "scr_2j0bc9" },
      { kind: "screen", id: "scr_jjl7zs" },
      { kind: "screen", id: "scr_ie2avj" },
      { kind: "screen", id: "scr_ndc1ch" },
      { kind: "screen", id: "scr_92mmvi" },
      { kind: "screen", id: "scr_0jxrdn" },
      { kind: "screen", id: "scr_a7vxvx" },
      { kind: "screen", id: "scr_6zc45g" },
      { kind: "screen", id: "scr_o45ezy" },
    ] },
  ],
}
